"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4379],{

/***/ 43812:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "$": function() { return /* reexport */ AdsContext; },
  "J": function() { return /* reexport */ useAdsProvider; }
});

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/typeof.js
var esm_typeof = __webpack_require__(86522);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(34795);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/toConsumableArray.js + 2 modules
var toConsumableArray = __webpack_require__(85942);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__(76854);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__(59740);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../utils/build/esm/index.js + 116 modules
var esm = __webpack_require__(6422);
// EXTERNAL MODULE: ../graphql/build/esm/index.js
var build_esm = __webpack_require__(76613);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(56666);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7896);
// EXTERNAL MODULE: ../../node_modules/lodash/filter.js
var filter = __webpack_require__(90882);
var filter_default = /*#__PURE__*/__webpack_require__.n(filter);
// EXTERNAL MODULE: ../../node_modules/lodash/flattenDeep.js
var flattenDeep = __webpack_require__(68632);
var flattenDeep_default = /*#__PURE__*/__webpack_require__.n(flattenDeep);
// EXTERNAL MODULE: ../structure/build-esm/index.js + 38 modules
var structure_build_esm = __webpack_require__(78642);
;// CONCATENATED MODULE: ../modules/build/esm/contexts/AdsContext/AdsContext.utils.js




var _excluded = ["id"],
  _excluded2 = ["product"];




var BANNERS_COMPONENT_NAME = 'AdsBanner';
var CAROUSEL_COMPONENT_NAME = 'AdsCarousel';
var HEADER_COMPONENT_NAME = 'HeaderDesktop';
var PRODUCTS_COMPONENT_NAME = 'AdsShowcase';
var ADS_COMPONENTS = [PRODUCTS_COMPONENT_NAME, BANNERS_COMPONENT_NAME, CAROUSEL_COMPONENT_NAME];
var DEFAULT_PRODUCT_CATEGORIES = ['MO', 'EP', 'CM', 'UD', 'ME'];
var getAllIds = function getAllIds(categories) {
  if (!categories.length) {
    return [];
  }
  var ids = [];
  function traverse(category) {
    if (category && (category == null ? void 0 : category.id) && ((category == null ? void 0 : category.subcategories) && (category == null ? void 0 : category.subcategories.length) || category.title)) {
      ids.push(category.id);
    }
    if (Array.isArray(category == null ? void 0 : category.subcategories)) {
      var _category$subcategori;
      category == null ? void 0 : (_category$subcategori = category.subcategories) == null ? void 0 : _category$subcategori.forEach(traverse);
    }
  }
  if (Array.isArray(categories)) {
    categories.forEach(traverse);
  } else if (categories) {
    traverse(categories);
  }
  var result = ids;
  result.shift();
  if (categories[0].subcategories.length) {
    var _categories$, _categories$$subcateg;
    result.unshift((_categories$ = categories[0]) == null ? void 0 : (_categories$$subcateg = _categories$.subcategories[0]) == null ? void 0 : _categories$$subcateg.id);
  }
  result = (0,toConsumableArray/* default */.Z)(new Set(result));
  return result.slice(0, 5);
};
var getCategories = function getCategories(category, viewedProducts, product, categoryPageId) {
  if (product && category) {
    return getAllIds(category);
  }
  if (categoryPageId) {
    return [categoryPageId];
  }
  if (viewedProducts == null ? void 0 : viewedProducts.length) {
    return (0,toConsumableArray/* default */.Z)(new Set([].concat(DEFAULT_PRODUCT_CATEGORIES, (0,toConsumableArray/* default */.Z)(viewedProducts)))).slice(-5);
  }
  return DEFAULT_PRODUCT_CATEGORIES;
};
var buildQuery = function buildQuery(_ref) {
  var _data$category, _data$category$, _data$product, _get, _get$items;
  var data = _ref.data,
    placements = _ref.placements,
    structure = _ref.structure;
  var _useStorage = (0,esm/* useStorage */.y$)('viewing-history'),
    get = _useStorage.get;
  var category = (data == null ? void 0 : data.category) || null;
  var categoryPageId = (data == null ? void 0 : (_data$category = data.category) == null ? void 0 : (_data$category$ = _data$category[0]) == null ? void 0 : _data$category$.id) || null;
  var product = (data == null ? void 0 : data.product) || null;
  var omittedProductIds = [data == null ? void 0 : (_data$product = data.product) == null ? void 0 : _data$product.id].filter(Boolean);
  var viewedProducts = ((_get = get()) == null ? void 0 : (_get$items = _get.items) == null ? void 0 : _get$items.map(function (item) {
    return item.category.id;
  })) || [];
  var banners = [];
  var products = [];
  var channelCode;
  var _useCookies = (0,esm/* useCookies */.fP)(),
    partnerId = _useCookies.partnerId,
    location = _useCookies.location,
    _useCookies$customerI = _useCookies.customerId,
    customerId = _useCookies$customerI === void 0 ? '' : _useCookies$customerI;
  placements.forEach(function (_ref2) {
    var name = _ref2.name,
      _ref2$categories = _ref2.categories,
      categories = _ref2$categories === void 0 ? [] : _ref2$categories,
      limit = _ref2.limit,
      slot = _ref2.slot,
      consumer = _ref2.consumer,
      channel = _ref2.channel,
      searchTerm = _ref2.searchTerm;
    if (name === PRODUCTS_COMPONENT_NAME) {
      var isDuplicateSlot = products.some(function (myProduct) {
        return myProduct.slot === slot;
      });
      if (!isDuplicateSlot) {
        products.push({
          categories: getCategories(category, viewedProducts, product, categoryPageId),
          consumer: consumer,
          limit: limit,
          slot: slot
        });
      }
    } else if ([BANNERS_COMPONENT_NAME, CAROUSEL_COMPONENT_NAME].includes(name)) {
      var parsed = (0,structure_build_esm/* parsePlaceholders */.VD)({
        categories: categories,
        searchTerm: searchTerm
      }, structure);
      banners.push((0,esm_extends/* default */.Z)({
        categories: categories,
        consumer: consumer,
        limit: limit,
        slot: slot
      }, parsed));
    }
    if (channel) {
      channelCode = channel;
    }
  });
  return (0,esm_extends/* default */.Z)({}, banners.length && {
    banners: banners
  }, {
    metadata: {
      channelCode: channelCode,
      customerId: customerId,
      isLoyalty: false,
      partnerId: partnerId
    },
    omitProductIds: omittedProductIds,
    products: products,
    zipcode: (location == null ? void 0 : location.zipCode) || ''
  });
};
var processComponents = function processComponents(structure) {
  var placementMap = new Map();
  var addAdComponent = function addAdComponent(_ref3) {
    var staticProps = _ref3["static"],
      name = _ref3.name;
    if (!ADS_COMPONENTS.includes(name)) return;
    var channel = staticProps.channel,
      categories = staticProps.categories,
      consumer = staticProps.consumer,
      _staticProps$limit = staticProps.limit,
      limit = _staticProps$limit === void 0 ? 1 : _staticProps$limit,
      slot = staticProps.slot,
      slots = staticProps.slots,
      searchTerm = staticProps.searchTerm;
    var slotArr = (slots !== null && slots !== void 0 ? slots : []).concat(slot ? {
      slot: slot
    } : []);
    var placementData = (0,esm_extends/* default */.Z)({
      categories: categories,
      channel: channel,
      consumer: consumer,
      limit: limit,
      name: name
    }, searchTerm && {
      searchTerm: searchTerm
    });
    var uniqueSlots = slotArr.filter(function (_ref4) {
      var slotData = _ref4.slot;
      return slotData && !placementMap.has(slotData);
    });
    uniqueSlots.forEach(function (slotData) {
      return placementMap.set(slotData, (0,esm_extends/* default */.Z)({}, placementData, slotData));
    });
  };
  var _processComponent = function processComponent(component) {
    addAdComponent(component);
    if (component == null ? void 0 : component.children) {
      component.children.forEach(_processComponent);
    }
    if (component.type === 'group') {
      component.components.forEach(_processComponent);
    }
    if (component.name === HEADER_COMPONENT_NAME) {
      var _component$static$men = component["static"].menuData.data,
        categoryList = _component$static$men.categoryList,
        allCategories = _component$static$men.allCategories;
      var menuBanners = categoryList.list.concat(allCategories).map(function (_ref5) {
        var adUnit = _ref5.adUnit;
        return {
          name: BANNERS_COMPONENT_NAME,
          "static": adUnit["static"]
        };
      });
      menuBanners.forEach(_processComponent);
    }
  };
  structure.components.forEach(_processComponent);
  return placementMap;
};
var buildQueryVariablesFromComponents = function buildQueryVariablesFromComponents(_ref6) {
  var data = _ref6.data,
    structure = _ref6.structure;
  if (Array.isArray(structure.components)) {
    var placementMap = processComponents(structure);
    if (placementMap.size) {
      return buildQuery({
        data: data,
        placements: Array.from(placementMap.values()),
        structure: structure
      });
    }
  }
  return null;
};
var parseAdsBanners = function parseAdsBanners(banners) {
  return banners.reduce(function (acc, banner) {
    (acc[banner.slot] = acc[banner.slot] || []).push(banner);
    return acc;
  }, {});
};
var parseProducts = function parseProducts(products) {
  return products.reduce(function (acc, product) {
    var _product$product = product.product,
      id = _product$product.id,
      restProduct = (0,objectWithoutProperties/* default */.Z)(_product$product, _excluded),
      rest = (0,objectWithoutProperties/* default */.Z)(product, _excluded2);
    var flattenedProduct = (0,esm_extends/* default */.Z)({
      id: id
    }, restProduct, rest);
    (acc[product.slot] = acc[product.slot] || []).push(flattenedProduct);
    return acc;
  }, {});
};
var parseAdsFillrates = function parseAdsFillrates(fillrates) {
  return fillrates.reduce(function (acc, fillrate) {
    return (0,esm_extends/* default */.Z)({}, acc, (0,defineProperty/* default */.Z)({}, fillrate.slotId, fillrate));
  }, {});
};
var normalizeAdsShowcaseFillratePayload = function normalizeAdsShowcaseFillratePayload(_ref7) {
  var _fillrate$received, _fillrate$requested, _fillrate$requested2, _fillrate$requested3;
  var fillrate = _ref7.fillrate,
    products = _ref7.products,
    staticProps = _ref7.staticProps;
  return {
    adType: 'SPONSORED_PRODUCT',
    channel: staticProps.channel,
    eventId: fillrate.eventId,
    page: staticProps.page,
    placement: fillrate.placement,
    received: {
      categories: [].concat((0,toConsumableArray/* default */.Z)(new Set(products.map(function (_ref8) {
        var category = _ref8.category;
        return category == null ? void 0 : category.id;
      }).filter(function (category) {
        return !!category;
      }))), (0,toConsumableArray/* default */.Z)(new Set(products.map(function (_ref9) {
        var subcategory = _ref9.subcategory;
        return subcategory == null ? void 0 : subcategory.id;
      }).filter(function (subcategory) {
        return !!subcategory;
      })))),
      clientAdsAmount: products.length,
      serverAdsAmount: (_fillrate$received = fillrate.received) == null ? void 0 : _fillrate$received.serverAdsAmount,
      skus: (0,toConsumableArray/* default */.Z)(new Set(products.map(function (_ref10) {
        var id = _ref10.id;
        return id;
      })))
    },
    requested: {
      categories: (_fillrate$requested = fillrate.requested) == null ? void 0 : _fillrate$requested.categories,
      clientAdsAmount: staticProps.limit,
      serverAdsAmount: (_fillrate$requested2 = fillrate.requested) == null ? void 0 : _fillrate$requested2.serverAdsAmount,
      skus: (_fillrate$requested3 = fillrate.requested) == null ? void 0 : _fillrate$requested3.skus
    }
  };
};
var _findAdsComponentsInStructureByName = function findAdsComponentsInStructureByName(components, name, uniqueKey) {
  if (!components) return [];
  var allComponents = filter_default()(flattenDeep_default()(components.map(function (component) {
    return [component].concat((0,toConsumableArray/* default */.Z)(component.components ? _findAdsComponentsInStructureByName(component.components, name) : []));
  })), function (component) {
    return component.name === name;
  });
  if (uniqueKey) {
    var uniqueMap = new Map();
    return allComponents.filter(function (component) {
      var key = component[uniqueKey];
      if (!uniqueMap.has(key)) {
        uniqueMap.set(key, true);
        return true;
      }
      return false;
    });
  }
  return allComponents;
};

;// CONCATENATED MODULE: ../modules/build/esm/contexts/AdsContext/AdsContext.js





var AdsContext_excluded = ["children"];
function _regeneratorRuntime() { "use strict"; _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == (0,esm_typeof/* default */.Z)(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError((0,esm_typeof/* default */.Z)(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }





var Context = (0,react.createContext)({});
var AdsContext = function AdsContext(_ref) {
  var children = _ref.children,
    props = (0,objectWithoutProperties/* default */.Z)(_ref, AdsContext_excluded);
  var data = props.data,
    structure = props.structure;
  var client = (0,build_esm.useClient)();
  var _useState = (0,react.useState)(),
    _useState2 = (0,slicedToArray/* default */.Z)(_useState, 2),
    ads = _useState2[0],
    setAds = _useState2[1];
  var _useState3 = (0,react.useState)(true),
    _useState4 = (0,slicedToArray/* default */.Z)(_useState3, 2),
    isLoading = _useState4[0],
    setIsLoading = _useState4[1];
  var _useAdsFillrateEvents = (0,build_esm.useAdsFillrateEvents)(),
    sendAdsFillrate = _useAdsFillrateEvents.sendAdsFillrate;
  var getBannerBySlot = function getBannerBySlot(slot) {
    var _ads$banners;
    return ads == null ? void 0 : (_ads$banners = ads.banners) == null ? void 0 : _ads$banners[slot];
  };
  var getProductsBySlot = function getProductsBySlot(slot) {
    var _ads$products;
    return ads == null ? void 0 : (_ads$products = ads.products) == null ? void 0 : _ads$products[slot];
  };
  var normalizeAndSendAdsFillrate = function normalizeAndSendAdsFillrate(resultAds, structureComponents) {
    var fillrateItems = [];
    try {
      fillrateItems = _findAdsComponentsInStructureByName(structureComponents, 'AdsShowcase', 'slot').reduce(function (acc, _ref2) {
        var staticProps = _ref2["static"];
        var fillrate = resultAds.fillrates[staticProps.slot];
        var products = resultAds.products[staticProps.slot];
        if (fillrate && products) {
          return [].concat((0,toConsumableArray/* default */.Z)(acc), [normalizeAdsShowcaseFillratePayload({
            fillrate: fillrate,
            products: products,
            staticProps: staticProps
          })]);
        }
        return acc;
      }, []);
    } catch (error) {
      console.error("Error normalizing fillrate payload: ".concat(error));
    }
    if (fillrateItems.length) {
      sendAdsFillrate(fillrateItems);
    }
  };
  var fetchContextAds = function () {
    var _ref3 = (0,asyncToGenerator/* default */.Z)(_regeneratorRuntime().mark(function _callee() {
      var _response$data$ads, _response$data$ads2, _response$data$ads3, variables, response, adsObj;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            setIsLoading(true);
            _context.prev = 1;
            variables = buildQueryVariablesFromComponents({
              data: data,
              structure: structure
            });
            if (variables) {
              _context.next = 5;
              break;
            }
            return _context.abrupt("return");
          case 5:
            _context.next = 7;
            return client.query({
              fetchPolicy: 'no-cache',
              query: build_esm.AdsQuery,
              variables: variables
            });
          case 7:
            response = _context.sent;
            adsObj = {
              banners: parseAdsBanners((response == null ? void 0 : (_response$data$ads = response.data.ads) == null ? void 0 : _response$data$ads.banners) || []),
              fillrates: parseAdsFillrates((response == null ? void 0 : (_response$data$ads2 = response.data.ads) == null ? void 0 : _response$data$ads2.fillrates) || []),
              products: parseProducts((response == null ? void 0 : (_response$data$ads3 = response.data.ads) == null ? void 0 : _response$data$ads3.products) || [])
            };
            setAds(adsObj);
            if (adsObj && (structure == null ? void 0 : structure.components)) {
              normalizeAndSendAdsFillrate(adsObj, structure.components);
            }
            _context.next = 16;
            break;
          case 13:
            _context.prev = 13;
            _context.t0 = _context["catch"](1);
            console.error("[useAdsProvider] - error: ".concat(_context.t0));
          case 16:
            _context.prev = 16;
            setIsLoading(false);
            return _context.finish(16);
          case 19:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[1, 13, 16, 19]]);
    }));
    return function fetchContextAds() {
      return _ref3.apply(this, arguments);
    };
  }();
  (0,react.useEffect)((0,asyncToGenerator/* default */.Z)(_regeneratorRuntime().mark(function _callee2() {
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          if (!esm/* whereAmI.onClient */.er.onClient) {
            _context2.next = 3;
            break;
          }
          _context2.next = 3;
          return fetchContextAds();
        case 3:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  })), [data]);
  return react.createElement(Context.Provider, {
    value: {
      ads: ads,
      getBannerBySlot: getBannerBySlot,
      getProductsBySlot: getProductsBySlot,
      isLoading: isLoading
    }
  }, children);
};
 false ? 0 : void 0;
AdsContext.defaultProps = {
  data: {}
};
var useAdsProvider = function useAdsProvider() {
  return (0,react.useContext)(Context);
};
;// CONCATENATED MODULE: ../modules/build/esm/contexts/AdsContext/index.js

;// CONCATENATED MODULE: ../modules/build/esm/contexts/index.js


/***/ }),

/***/ 89382:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _babel_runtime_helpers_esm_taggedTemplateLiteral__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(71171);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(13980);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99673);

var _templateObject;



var Layout = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div */ .ZP.div(_templateObject || (_templateObject = (0,_babel_runtime_helpers_esm_taggedTemplateLiteral__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(["\n  ", ";\n"])), function (props) {
  return props.layout;
});
var withLayoutProps = function withLayoutProps(Component) {
  var WrapComponent = function WrapComponent(props) {
    var _Component$name;
    var layout = props.layout;
    var testid = "mod-".concat((_Component$name = Component.name) == null ? void 0 : _Component$name.toLowerCase());
    return Object.keys(layout).length ? react__WEBPACK_IMPORTED_MODULE_0__.createElement(Layout, {
      layout: layout,
      "data-testid": testid
    }, react__WEBPACK_IMPORTED_MODULE_0__.createElement(Component, props)) : react__WEBPACK_IMPORTED_MODULE_0__.createElement(Component, props);
  };
  WrapComponent.defaultProps = {
    layout: {}
  };
   false ? 0 : void 0;
  WrapComponent.dataSource = Component.dataSource;
  WrapComponent.ssr = Component.ssr;
  WrapComponent.displayName = Component.displayName || Component.name;
  return WrapComponent;
};
/* harmony default export */ __webpack_exports__["Z"] = (withLayoutProps);

/***/ })

}]);